import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "create-framework-project-modal";

const keys = addTranslations(RESOURCE_NAME, {
    open_button: {
        en: "Create project",
        fr: "Créer un projet",
    },
    title: {
        en: "Create new project",
        fr: "Créer un nouveau projet",
    },
    settings: {
        en: "Project settings",
        fr: "Paramètres du projet",
    },
    settings_description: {
        en: "Once the Framework and language are set, they can not be changed for this project.",
        fr: "Une fois le référentiel et la langue définis, ils ne peuvent pas être modifiés pour ce projet.",
    },
    input_framework: {
        en: "Framework",
        fr: "Référentiel",
    },
    input_framework_description: {
        en: "The Framework must be active in order to create a new project for it.",
        fr: "Le référentiel doit être actif pour créer un nouveau projet.",
    },
    input_locale: {
        en: "Language",
        fr: "Langue",
    },
    input_locale_description: {
        en: "Some Frameworks are available in multiple languages, while others only support one.",
        fr: "Certains référentiels sont disponibles dans plusieurs langues, tandis que d'autres ne supportent qu'une seule langue.",
    },
    input_locale_empty_state: {
        en: "No language available",
        fr: "Aucune langue disponible",
    },
    locale_fr: {
        en: "French",
        fr: "Français",
    },
    locale_en: {
        en: "English",
        fr: "Anglais",
    },
    input_period: {
        en: "Period",
        fr: "Période",
    },
    input_entity: {
        en: "Entity",
        fr: "Entité",
    },
    action_button_create: {
        en: "Create",
        fr: "Créer",
    },
    action_button_cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    tags_section_title: {
        en: "Select tags",
        fr: "Sélectionner des tags",
    },
    tags_section_description: {
        en: "Chose topics that are material to your organization",
        fr: "Choisissez les sujets qui sont pertinents pour votre organisation",
    },
    action_button_create_disabled_tooltip: {
        en: "Please fill in all the fields",
        fr: "Veuillez remplir tous les champs",
    },
    upload_evs_questionnaire: {
        en: "Upload Ecovadis excel questionnaire",
        fr: "Uploadez le questionnaire Ecovadis au format Excel",
    },
    uploaded_file: {
        en: "File",
        fr: "Fichier",
    },
    ecovadis_success_message: {
        en: "Your questionnaire is being created. This will take a few minutes.",
        fr: "Votre questionnaire est en cours de création. Cela prendra quelques minutes.",
    },
});
export function useCreateFrameworkProjectModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
